export default {
  manual: 'Manuell',
  filters: {
    status: 'Status',
    event_type: 'Ereignistyp',
  },
  columns: {
    event: 'Ereignis',
    status: 'Status',
    attempts: 'Versuche',
    last_http_status: 'Letzter HTTP-Status',
    created_at: 'Erstellt',
  },
  statuses: {
    pending: 'Ausstehend',
    delivered: 'Zugestellt',
    failed: 'Fehlgeschlagen',
  },
  buttons: {
    details: 'Details',
    resend: 'Erneut senden',
  },
  detail: {
    title: 'Zustellungsdetails',
    event: 'Ereignis',
    attempts: 'Versuche',
    no_attempts: 'Noch keine Versuche.',
    no_response: 'keine Antwort',
    payload: 'Payload',
  },
  toasts: {
    load_error: 'Die Zustellungen konnten nicht geladen werden.',
    resend_error: 'Die Zustellung konnte nicht erneut gesendet werden.',
    resent: 'Zustellung wird erneut gesendet.',
  },
};
